// extracted by mini-css-extract-plugin
export var errorIcon = "_o9-1";
export var nameLogo = "_o9-0";